import { Controller } from "@hotwired/stimulus"
import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { camelizeKeys } from 'humps'
import { components } from './jsx/components_registry.js'

// Stimulus controller for mounting React components (Turbo-compatible)
export default class extends Controller {
  static values = {
    component: String,
    props: Object
  }

  connect() {
    console.log('React component controller connected:', this.componentValue)
    this.mountReactComponent()
  }

  disconnect() {
    console.log('React component controller disconnecting:', this.componentValue)
    
    // Don't unmount permanent elements - they persist across Turbo navigations
    const isPermanent = this.element.hasAttribute('data-turbo-permanent')
    if (!isPermanent) {
      this.unmountReactComponent()
    }
  }

  mountReactComponent() {
    // If root already exists (e.g., for permanent elements), don't recreate
    if (this.root) {
      console.log('React component already mounted, skipping remount')
      return
    }
    
    const Component = components[this.componentValue]
    
    if (!Component) {
      console.error(`React component "${this.componentValue}" not found in registry`)
      return
    }

    // Convert snake_case props to camelCase
    const props = camelizeKeys(this.propsValue || {})

    console.log('Mounting React component with props:', props)
    
    // Create root and render
    this.root = createRoot(this.element)
    this.root.render(React.createElement(Component, props))
  }

  unmountReactComponent() {
    if (this.root) {
      this.root.unmount()
      this.root = null
    }
  }
}

